import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

export type Visibility = 'fadeInOut' | 'hide' | 'show'

type Props = {
  children: React.ReactNode
  className?: string
  visibility?: Visibility
}

function ToolTip(props: Props) {
  const { className, children, visibility = 'fadeInOut' } = props

  return (
    <>
      <span
        aria-live='polite'
        className={classNames(style.srAlert, {
          [style.srDisplay]: visibility === 'show',
        })}
        data-testid='toolTipAlert'
        role='alert'
      >
        {children}
      </span>
      <div
        aria-hidden
        className={classNames(style.wrapper, className, style[visibility])}
        data-testid='toolTip'
      >
        {children}
      </div>
    </>
  )
}

export default ToolTip
